import { ReactElement, useMemo } from 'react';
import { Box } from '@mui/material';
import { useFormikContext } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRotateRight as RepetionIcon } from '@fortawesome/free-solid-svg-icons';

import { getRouteScheduleRepitionTypeDescriptionPrefix } from '~utils/scheduleRoute/repetionType';
import DescriptionWithIconBox from '~components/DescriptionWithIconBox';

import {
  SCHEDULE_ROUTE_BASE_FORM_FIELDS_NAME,
  getScheduleRouteBaseFormInititalValues,
} from '../../../utils/scheduleRouteForm';

const AssistantGenerateRoutesDialogScheduleRouteCardIndicator =
  (): ReactElement => {
    const { values } =
      useFormikContext<
        ReturnType<typeof getScheduleRouteBaseFormInititalValues>
      >();

    const scheduleRouteEnabledValue = useMemo(
      () => values[SCHEDULE_ROUTE_BASE_FORM_FIELDS_NAME.SCHEDULE_ROUTE_ENABLED],
      [values],
    );

    const scheduleRouteRepetionTypeValue = useMemo(
      () =>
        values[
          SCHEDULE_ROUTE_BASE_FORM_FIELDS_NAME.SCHEDULE_ROUTE_REPETION_TYPE
        ],
      [values],
    );

    const description = useMemo(() => {
      let text = 'Sin repetición';

      if (scheduleRouteEnabledValue) {
        text = getRouteScheduleRepitionTypeDescriptionPrefix(
          scheduleRouteRepetionTypeValue,
        );
      }

      return text.toUpperCase();
    }, [scheduleRouteEnabledValue, scheduleRouteRepetionTypeValue]);

    return (
      <Box marginRight={2}>
        <DescriptionWithIconBox
          icon={<FontAwesomeIcon icon={RepetionIcon} />}
          description={description}
          size={14}
          fontWeight="bold"
        />
      </Box>
    );
  };

export default AssistantGenerateRoutesDialogScheduleRouteCardIndicator;
